module.exports = __webpack_public_path__ + "static/media/power-stering-fluid-exchange.5031ca68.svg";